import {Collection} from 'vue-mc';
import Config from "../config/config";
import manualReportModel  from "@/models/manualReportModel";

export default class manualReportCollection extends Collection {


	model() {
		return manualReportModel;
	}

	// Route configuration
	routes() {
		return {
			fetch: Config.localApiURL + 'clients/manual/list/'
		}
	}
}



// WEBPACK FOOTER //
// ./src/collections/manualReportCollection.js